const nonMutatingArray = (value)=>{

    return JSON.parse(JSON.stringify(value));
}

export default nonMutatingArray;

